import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=0d5584da&scoped=true"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
import "./UnsavedChangesModal.vue?vue&type=style&index=0&id=0d5584da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5584da",
  null
  
)

export default component.exports